<template>
    <el-dialog title="住院床位安排" :visible.sync="showTag" width="25%">
        <div class="main">
            <div class="pt15">
                <h3 class="fs16">预约信息</h3>
                <ul>
                    <li>
                        <span>姓名：</span>
                        <span>{{order.patName}}</span>
                    </li>
                    <li>
                        <span>身份证：</span>
                        <span>{{order.patIdcard|hiddenStr(6,4,8)}}</span>
                    </li>
                    <li>
                        <span>手机号：</span>
                        <span>{{order.patMobile|hiddenStr(3,4,4)}}</span>
                    </li>
                    <li>
                        <span>预约时间：</span>
                        <span>{{num.date|timeFormat('%Y-%m-%d')}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div slot="footer">
            <el-button type="danger" @click="hide" size="mini">取消</el-button>
            <el-button type="primary" @click="handler" size="mini">确定安排床位</el-button>
        </div>
    </el-dialog>
</template>
<style scoped lang="scss">
    @import "../../styles/var";
    @import "../../styles/mixins";

    .main {
        margin-top: -30px;
        margin-left: -5px;
        margin-right: -5px;

        ul {
            padding-top: 10px;

            li + li {
                margin-top: 10px
            }
        }
    }
</style>
<script>
  import {ampmFilter, hiddenStr, schdateFilter} from "../../lib/filters";
  import {timeFormat} from "../../lib/utils";

  export default {
    name: "referral-bed-confirm-dialog",
    data() {
      return {
        order: {},
        num: {},
        showTag: false,
      }
    },
    computed: {},
    filters: {schdateFilter, ampmFilter, timeFormat, hiddenStr},
    created() {
    },
    methods: {
      async show(data) {
        this.order = data.order;
        this.num = data.num;
        this.showTag = true;
      },
      hide() {
        this.showTag = false;
      },
      handler() {
        this.hide();
        this.$emit('submit', '确定床位预约', {
          id: this.order.id,
          acceptTime: timeFormat(this.num.date, '%Y-%m-%d'),
          referralResult: 1
        });
      }
    },
  }
</script>

